import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'

import { ENV } from '@/common/constants/env'

if (ENV.MODE === 'production') {
  Sentry.init({
    dsn: ENV.VITE_SENTRY_DSN,
    environment: ENV.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
  })
}

export const SentryRoutes =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
